import { Col, message, Row } from 'antd';
import { func, object, string } from 'prop-types';
import React, { Fragment } from 'react';
import { USER_ROLES } from '../../../api/constants';
import { theme } from '../../../styles';
import copyToClipboard from '../../../utils/copyToClipboard';
import { EMAIL } from '../../../utils/regexp';
import {
  CopyButton,
  CopyToClipboardWr,
  InvitationLink,
} from '../styled-components';
import {
  AddUserButton,
  FormItemS,
  FormS,
  IconS,
  InputS,
  RadioGroupS,
  RadioS,
} from './styled-components';

const { ADMIN, USER, SALES_AGENT } = USER_ROLES;

const InviteUserForm = ({
  form: { getFieldDecorator },
  onInviteUser,
  authorizedUser,
  invitationLink,
  invitationsUser,
}) => (
  <Fragment>
    <FormS>
      <Row gutter={12}>
        <Col xs={24} sm={12}>
          <FormItemS>
            {getFieldDecorator('email', {
              rules: [
                {
                  pattern: EMAIL,
                  required: true,
                  message: 'The input is not valid Email!',
                },
              ],
            })(<InputS
              prefix={
                <IconS
                  type="message"
                  size={21}
                  color={theme.colors.backgroundSilver}
                />
              }
              placeholder="Type Email here…"
              size="large"
              name="email"
            />)}
          </FormItemS>
        </Col>
        <Col xs={24} sm={12}>
          <FormItemS>
            {getFieldDecorator('fullName', {
              rules: [
                {
                  required: true,
                  message: 'Please input full name',
                },
              ],
            })(<InputS
              prefix={
                <IconS
                  type="user"
                  size={19}
                  color={theme.colors.backgroundSilver}
                />
              }
              placeholder="Full name"
              size="large"
              name="fullName"
            />)}
          </FormItemS>
        </Col>
      </Row>
      {authorizedUser.role === USER_ROLES.SUPER_ADMIN &&
        getFieldDecorator('role')(<RadioGroupS>
          <RadioS value={USER}>User</RadioS>
          <RadioS value={SALES_AGENT}>Sales Agent</RadioS>
          <RadioS value={ADMIN}>Admin</RadioS>
        </RadioGroupS>)}
      <AddUserButton
        onClick={onInviteUser}
        isLoading={invitationsUser.isInvitingUser}
        disabled={invitationsUser.isInvitingUser}
      >
        Invite user
      </AddUserButton>
    </FormS>
    {invitationLink && (
      <CopyToClipboardWr>
        <InvitationLink>{invitationLink}</InvitationLink>
        <CopyButton
          onClick={() =>
            copyToClipboard(
              invitationLink,
              () => message.success('Link successfully copied'),
            )
          }
        >
          Copy to clipboard
        </CopyButton>
      </CopyToClipboardWr>
    )}
  </Fragment>
);

InviteUserForm.propTypes = {
  onInviteUser: func.isRequired,
  form: object.isRequired,
  invitationsUser: object.isRequired,
  invitationLink: string.isRequired,
  authorizedUser: object.isRequired,
};

export default InviteUserForm;



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/invite-user-form/invite-user-form-comp.js